module.exports = __webpack_public_path__ + "img/time.77c69d75.jpg";